import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { FormGroup, FormArray, FormControl, AbstractControl, Validators } from '@angular/forms';
import { FormlyConfig } from './formly.config';
import { evalStringExpression, evalExpressionValueSetter, evalExpression, getFieldId, assignModelValue, isObject } from './../utils';
import { getKeyPath, isUndefined } from '../utils';
var FormlyFormBuilder = (function () {
    function FormlyFormBuilder(formlyConfig) {
        this.formlyConfig = formlyConfig;
        this.validationOpts = ['required', 'pattern', 'minLength', 'maxLength', 'min', 'max'];
        this.formId = 0;
    }
    FormlyFormBuilder.prototype.buildForm = function (form, fields, model, options) {
        if (fields === void 0) { fields = []; }
        this.formId++;
        options = options || {};
        if (!options.showError) {
            options.showError = this.formlyConfig.extras.showError;
        }
        var fieldTransforms = (options && options.fieldTransform) || this.formlyConfig.extras.fieldTransform;
        if (!Array.isArray(fieldTransforms)) {
            fieldTransforms = [fieldTransforms];
        }
        fieldTransforms.forEach(function (fieldTransform) {
            if (fieldTransform) {
                fields = fieldTransform(fields, model, form, options);
                if (!fields) {
                    throw new Error('fieldTransform must return an array of fields');
                }
            }
        });
        this.registerFormControls(form, fields, model, options);
    };
    FormlyFormBuilder.prototype.registerFormControls = function (form, fields, model, options) {
        var _this = this;
        fields.map(function (field, index) {
            field.id = getFieldId("formly_" + _this.formId, field, index);
            _this.initFieldTemplateOptions(field);
            _this.initFieldExpression(field, model, options);
            _this.initFieldValidation(field);
            _this.initFieldAsyncValidation(field);
            if (field.key && field.type) {
                _this.formlyConfig.getMergedField(field);
                var path = field.key;
                if (typeof path === 'string') {
                    if (!isUndefined(field.defaultValue)) {
                        _this.defaultPath = path;
                    }
                    path = getKeyPath({ key: field.key });
                }
                if (path.length > 1) {
                    var rootPath = path.shift();
                    var nestedForm = (form.get(rootPath.toString()) ? form.get(rootPath.toString()) : new FormGroup({}));
                    if (!form.get(rootPath.toString())) {
                        form.addControl(rootPath, nestedForm);
                    }
                    if (!model[rootPath]) {
                        model[rootPath] = isNaN(path[0]) ? {} : [];
                    }
                    var originalKey = field.key;
                    field.key = path;
                    _this.buildForm(nestedForm, [field], model[rootPath], options);
                    field.key = originalKey;
                }
                else {
                    if (!isUndefined(field.defaultValue) && isUndefined(model[path[0]])) {
                        var modelPath = getKeyPath({ key: _this.defaultPath });
                        modelPath = modelPath.pop();
                        assignModelValue(model, modelPath, field.defaultValue);
                        _this.defaultPath = undefined;
                    }
                    _this.addFormControl(form, field, model[path[0]]);
                }
            }
            if (field.fieldGroup) {
                if (field.key) {
                    if (!model.hasOwnProperty(field.key)) {
                        model[field.key] = {};
                    }
                    var nestedForm = form.get(field.key), nestedModel = model[field.key] || {};
                    if (!nestedForm) {
                        nestedForm = new FormGroup({}, field.validators ? field.validators.validation : undefined, field.asyncValidators ? field.asyncValidators.validation : undefined);
                        _this.addControl(form, field.key, nestedForm, field);
                    }
                    _this.buildForm(nestedForm, field.fieldGroup, nestedModel, options);
                }
                else {
                    _this.buildForm(form, field.fieldGroup, model, options);
                }
            }
            if (field.fieldArray && field.key) {
                if (!(form.get(field.key) instanceof FormArray)) {
                    var arrayForm = new FormArray([], field.validators ? field.validators.validation : undefined, field.asyncValidators ? field.asyncValidators.validation : undefined);
                    _this.addControl(form, field.key, arrayForm, field);
                }
            }
        });
    };
    FormlyFormBuilder.prototype.initFieldExpression = function (field, model, options) {
        options.formState = options.formState || {};
        if (field.expressionProperties) {
            for (var key in field.expressionProperties) {
                if (typeof field.expressionProperties[key] === 'string') {
                    field.expressionProperties[key] = {
                        expression: evalStringExpression(field.expressionProperties[key], ['model', 'formState']),
                        expressionValueSetter: evalExpressionValueSetter(key, ['expressionValue', 'model', 'templateOptions', 'validation']),
                    };
                }
                var expressionValue = evalExpression(field.expressionProperties[key].expression, { field: field }, [model, options.formState]);
                field.expressionProperties[key].expressionValue = expressionValue;
                evalExpression(field.expressionProperties[key].expressionValueSetter, { field: field }, [expressionValue, model, field.templateOptions || {}, field.validation]);
            }
        }
        if (typeof field.hideExpression === 'string') {
            field.hideExpression = evalStringExpression(field.hideExpression, ['model', 'formState']);
            field.hide = evalExpression(field.hideExpression, { field: field }, [model, options.formState]);
        }
    };
    FormlyFormBuilder.prototype.initFieldTemplateOptions = function (field) {
        if (field.key && field.type) {
            field.templateOptions = Object.assign({
                label: '',
                placeholder: '',
                focus: false,
            }, field.templateOptions);
        }
    };
    FormlyFormBuilder.prototype.initFieldAsyncValidation = function (field) {
        var _this = this;
        var validators = [];
        if (field.asyncValidators) {
            var _loop_1 = function (validatorName) {
                if (validatorName !== 'validation') {
                    validators.push(function (control) {
                        var validator = field.asyncValidators[validatorName];
                        if (isObject(validator)) {
                            validator = validator.expression;
                        }
                        return new Promise(function (resolve) {
                            return validator(control).then(function (result) {
                                resolve(result ? null : (_a = {}, _a[validatorName] = true, _a));
                                var _a;
                            });
                        });
                    });
                }
            };
            for (var validatorName in field.asyncValidators) {
                _loop_1(validatorName);
            }
        }
        if (field.asyncValidators && Array.isArray(field.asyncValidators.validation)) {
            field.asyncValidators.validation.map(function (validate) {
                if (typeof validate === 'string') {
                    validators.push(_this.formlyConfig.getValidator(validate).validation);
                }
                else {
                    validators.push(validate);
                }
            });
        }
        if (validators.length) {
            if (field.asyncValidators && !Array.isArray(field.asyncValidators.validation)) {
                field.asyncValidators.validation = Validators.composeAsync([field.asyncValidators.validation].concat(validators));
            }
            else {
                field.asyncValidators = {
                    validation: Validators.composeAsync(validators),
                };
            }
        }
    };
    FormlyFormBuilder.prototype.initFieldValidation = function (field) {
        var _this = this;
        var validators = [];
        this.validationOpts.filter(function (opt) { return field.templateOptions && field.templateOptions[opt]; }).map(function (opt) {
            validators.push(_this.getValidation(opt, field.templateOptions[opt]));
        });
        if (field.validators) {
            var _loop_2 = function (validatorName) {
                if (validatorName !== 'validation') {
                    validators.push(function (control) {
                        var validator = field.validators[validatorName];
                        if (isObject(validator)) {
                            validator = validator.expression;
                        }
                        return validator(control) ? null : (_a = {}, _a[validatorName] = true, _a);
                        var _a;
                    });
                }
            };
            for (var validatorName in field.validators) {
                _loop_2(validatorName);
            }
        }
        if (field.validators && Array.isArray(field.validators.validation)) {
            field.validators.validation.map(function (validate) {
                if (typeof validate === 'string') {
                    validators.push(_this.formlyConfig.getValidator(validate).validation);
                }
                else {
                    validators.push(validate);
                }
            });
        }
        if (validators.length) {
            if (field.validators && !Array.isArray(field.validators.validation)) {
                field.validators.validation = Validators.compose([field.validators.validation].concat(validators));
            }
            else {
                field.validators = {
                    validation: Validators.compose(validators),
                };
            }
        }
    };
    FormlyFormBuilder.prototype.addFormControl = function (form, field, model) {
        var name = typeof field.key === 'string' ? field.key : field.key[0], formControl;
        if (field.formControl instanceof AbstractControl) {
            formControl = field.formControl;
        }
        else if (field.component && field.component.createControl) {
            formControl = field.component.createControl(model, field);
        }
        else {
            formControl = new FormControl(model, field.validators ? field.validators.validation : undefined, field.asyncValidators ? field.asyncValidators.validation : undefined);
        }
        if (field.templateOptions.disabled) {
            formControl.disable();
        }
        this.addControl(form, name, formControl, field);
        if (field.validation && field.validation.show) {
            formControl.markAsTouched();
        }
    };
    FormlyFormBuilder.prototype.getValidation = function (opt, value) {
        var _this = this;
        switch (opt) {
            case 'required':
                return Validators.required;
            case 'pattern':
                return Validators.pattern(value);
            case 'minLength':
                return Validators.minLength(value);
            case 'maxLength':
                return Validators.maxLength(value);
            case 'min':
            case 'max':
                return function (changes) {
                    if (_this.checkMinMax(opt, changes.value, value)) {
                        return null;
                    }
                    else {
                        return _a = {}, _a[opt] = true, _a;
                    }
                    var _a;
                };
        }
    };
    FormlyFormBuilder.prototype.checkMinMax = function (opt, changes, value) {
        if (changes == null || changes === '') {
            return true;
        }
        if (opt === 'min') {
            return parseInt(changes) >= value;
        }
        return parseInt(changes) <= value;
    };
    FormlyFormBuilder.prototype.addControl = function (form, key, formControl, field) {
        field.formControl = formControl;
        if (field.hide) {
            return;
        }
        if (formControl instanceof FormArray) {
            form.setControl(key, formControl);
        }
        else {
            form.addControl(key, formControl);
        }
    };
    return FormlyFormBuilder;
}());
FormlyFormBuilder = tslib_1.__decorate([
    Injectable(),
    tslib_1.__metadata("design:paramtypes", [FormlyConfig])
], FormlyFormBuilder);
export { FormlyFormBuilder };
//# sourceMappingURL=formly.form.builder.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/services/formly.form.builder.js
// module id = 182
// module chunks = 3